(function (window, document) {
  'use strict';

  var GUIDE_ID = 'rednote-open-browser-guide';
  var STYLE_ID = 'rednote-app-launcher-style';

  function getUserAgent() {
    return (window.navigator && window.navigator.userAgent) || '';
  }

  function getEnvironment() {
    var nav = window.navigator || {};
    var ua = getUserAgent();
    var platform = nav.platform || '';
    var maxTouchPoints = nav.maxTouchPoints || 0;
    var isHarmonyOS = isHarmonyUserAgent(ua);
    var isHarmonyUniversalLinkPreferred =
      isHarmonyOS && shouldUseHarmonyUniversalLink(ua);
    var isIOS =
      /iPad|iPhone|iPod/i.test(ua) ||
      (platform === 'MacIntel' && maxTouchPoints > 1);
    var isAndroidLike = !isHarmonyOS && /Android|Adr/i.test(ua);
    var inAppBrowser = detectInAppBrowser(ua);

    return {
      userAgent: ua,
      isIOS: isIOS,
      isHarmonyOS: isHarmonyOS,
      isHarmonyUniversalLinkPreferred: isHarmonyUniversalLinkPreferred,
      isAndroidLike: isAndroidLike,
      isMobile: isIOS || isHarmonyOS || isAndroidLike,
      inAppBrowser: inAppBrowser,
      isInAppBrowser: Boolean(inAppBrowser),
    };
  }

  function detectInAppBrowser(ua) {
    if (/wxwork|WeCom/i.test(ua)) {
      return { name: '企业微信', code: 'wework' };
    }
    if (/MicroMessenger/i.test(ua)) {
      return { name: '微信', code: 'wechat' };
    }
    if (/\bQQ\//i.test(ua) || /MQQBrowser/i.test(ua)) {
      return { name: 'QQ', code: 'qq' };
    }
    if (/Weibo/i.test(ua)) {
      return { name: '微博', code: 'weibo' };
    }
    if (/DingTalk/i.test(ua)) {
      return { name: '钉钉', code: 'dingtalk' };
    }
    if (/Lark|Feishu/i.test(ua)) {
      return { name: '飞书', code: 'lark' };
    }
    if (/AlipayClient/i.test(ua)) {
      return { name: '支付宝', code: 'alipay' };
    }
    if (/NewsArticle|ToutiaoMicroApp/i.test(ua)) {
      return { name: '今日头条', code: 'toutiao' };
    }
    if (/Aweme/i.test(ua)) {
      return { name: '抖音', code: 'douyin' };
    }
    return null;
  }

  function isHttpUrl(url) {
    return typeof url === 'string' && /^https?:\/\//i.test(url);
  }

  function isHarmonyUserAgent(ua) {
    return /HarmonyOS|OpenHarmony|ArkWeb|HMOS|Harmony\/|huawei_hm/i.test(ua);
  }

  function shouldUseHarmonyUniversalLink(ua) {
    return /ArkWeb/i.test(ua);
  }

  function navigateToUrl(url, method) {
    if (method === 'anchor' && document.body) {
      var link = document.createElement('a');
      link.href = url;
      link.style.display = 'none';
      link.setAttribute('aria-hidden', 'true');
      document.body.appendChild(link);

      if (typeof link.click === 'function') {
        link.click();
      } else {
        window.location.href = url;
      }

      window.setTimeout(function () {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      }, 0);
      return;
    }

    window.location.href = url;
  }

  function createShareSessionId() {
    var cryptoObj = window.crypto || window.msCrypto;
    if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
      return cryptoObj.randomUUID();
    }
    return (
      'rednote_publish_' +
      Date.now() +
      '_' +
      Math.random().toString(36).slice(2)
    );
  }

  function encodeUtf8ToBase64(value) {
    if (typeof TextEncoder !== 'undefined') {
      var bytes = new TextEncoder().encode(value);
      var binary = '';
      for (var i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    }

    return btoa(unescape(encodeURIComponent(value)));
  }

  function normalizeImages(shareInfo) {
    if (!shareInfo || !Array.isArray(shareInfo.images)) return [];
    return shareInfo.images.filter(isHttpUrl);
  }

  function normalizeVideo(shareInfo) {
    if (!shareInfo || !isHttpUrl(shareInfo.video)) return null;
    return {
      video: {
        uri: null,
        url: shareInfo.video,
      },
      cover: isHttpUrl(shareInfo.cover)
        ? {
            uri: null,
            url: shareInfo.cover,
          }
        : undefined,
    };
  }

  function hasValidNormalMedia(shareInfo) {
    return (
      shareInfo &&
      shareInfo.type === 'normal' &&
      Array.isArray(shareInfo.images) &&
      shareInfo.images.length > 0 &&
      shareInfo.images.every(isHttpUrl)
    );
  }

  function hasValidVideoMedia(shareInfo) {
    return shareInfo && shareInfo.type === 'video' && isHttpUrl(shareInfo.video);
  }

  function buildIOSTopicContent(content) {
    var value = typeof content === 'string' ? content : '';
    var result = '';
    var i = 0;

    while (i < value.length) {
      var char = value.charAt(i);
      if (char !== '#' || !shouldConvertIOSTopicMarker(value, i)) {
        result += char;
        i += 1;
        continue;
      }

      var start = i + 1;
      var end = start;
      while (end < value.length && isIOSTopicNameChar(value.charAt(end))) {
        end += 1;
      }

      var topicName = value.slice(start, end);
      var marker = value.slice(end, end + 5);
      if (marker === '[话题]#') {
        result += '#' + topicName + marker;
        i = end + 5;
      } else {
        result += '#' + topicName + '[话题]#';
        i = end;
      }
    }

    return result;
  }

  function shouldConvertIOSTopicMarker(value, index) {
    var next = value.charAt(index + 1);
    if (!next || !isIOSTopicNameChar(next)) return false;

    var prev = index > 0 ? value.charAt(index - 1) : '';
    if (!prev) return true;

    return !/[A-Za-z0-9_/-]/.test(prev);
  }

  function isIOSTopicNameChar(char) {
    if (!char || /\s/.test(char)) return false;
    return (
      '#[]{}()（）<>《》【】.,，。!！?？;；:：、/\\|"“”‘’`~@$%^&*=+'
        .indexOf(char) === -1
    );
  }

  function canOpenPublish(shareInfo) {
    var env = getEnvironment();
    return (
      env.isMobile &&
      (hasValidNormalMedia(shareInfo) || hasValidVideoMedia(shareInfo))
    );
  }

  function buildShareSdkData(shareInfo, options) {
    var opts = options || {};
    var images = normalizeImages(shareInfo);
    var videoInfo = normalizeVideo(shareInfo);
    var noteInfo = {
      title: { value: shareInfo.title || '' },
      content: { value: shareInfo.content || '' },
    };

    if (hasValidNormalMedia(shareInfo)) {
      noteInfo.image_info = images.map(function (url) {
        return {
          uri: null,
          url: url,
        };
      });
    } else if (videoInfo) {
      noteInfo.video_info = videoInfo;
    }

    var shareData = {
      note_info: noteInfo,
      // XHS still treats video notes as note shares; video_publish is selected
      // from note_info.video_info inside the app.
      share_type: 'note',
      sdk_version: opts.sdkVersion || '1.0.0',
      third_app_package: opts.thirdAppPackage || 'system_album_other',
      third_app_version: opts.thirdAppVersion || '1.0.0',
      share_session_id: createShareSessionId(),
      did: opts.did || '',
      start_share_timestamp: Date.now(),
    };

    if (opts.includeFromJsSdk !== false) {
      shareData.fromJsSdk = false;
    }

    return shareData;
  }

  function buildAndroidRoute(shareInfo) {
    return buildShareSdkSchema(shareInfo);
  }

  function buildShareSdkSchema(shareInfo, options) {
    var shareData = buildShareSdkData(shareInfo, options);

    return (
      'xhsdiscover://share_sdk?data=' +
      encodeURIComponent(encodeUtf8ToBase64(JSON.stringify(shareData)))
    );
  }

  function buildHarmonyRoute(shareInfo) {
    return buildShareSdkSchema(shareInfo, {
      sdkVersion: '1.0.4',
      includeFromJsSdk: false,
    });
  }

  function buildHarmonyUniversalLinkRoute(shareInfo) {
    var shareData = buildShareSdkData(shareInfo, {
      sdkVersion: '1.0.4',
      includeFromJsSdk: false,
    });

    return (
      'https://www.xiaohongshu.com/open/new_sdk/ul?data=' +
      encodeURIComponent(encodeUtf8ToBase64(JSON.stringify(shareData)))
    );
  }

  function buildIOSShareSdkRoute(shareInfo) {
    return (
      'https://oia.xiaohongshu.com/oia?deeplink=' +
      encodeURIComponent(buildShareSdkSchema(shareInfo))
    );
  }

  function buildIOSRoute(shareInfo, images) {
    var content = buildIOSTopicContent(shareInfo.content || '');
    var iosImageResources = images.map(function (url) {
      return {
        image_url: url,
        url: url,
        imageUrl: url,
        uri: url,
      };
    });
    var attach = {
      image_resources: iosImageResources,
      images: images,
      note_title: shareInfo.title || '',
      note_text: content,
      note_text_v2: {
        content: content,
      },
      now_edit_info: {
        tti_open_keyboard: false,
      },
    };
    var pageInfo = { page_type: 'photo_publish' };
    var source = {
      type: 'system_album_other',
      externalSource: 'rednote_publish_direct',
      extraInfo: { subType: 'external_app' },
    };
    var schema =
      'xhsdiscover://post_new_note?attach=' +
      encodeURIComponent(JSON.stringify(attach)) +
      '&page=' +
      encodeURIComponent(JSON.stringify(pageInfo)) +
      '&source=' +
      encodeURIComponent(JSON.stringify(source));

    return (
      'https://oia.xiaohongshu.com/oia?deeplink=' +
      encodeURIComponent(schema)
    );
  }

  function buildIOSVideoRoute(shareInfo) {
    var content = buildIOSTopicContent(shareInfo.content || '');
    var videoResources = {
      video_url: shareInfo.video,
    };
    if (isHttpUrl(shareInfo.cover)) {
      videoResources.cover_url = shareInfo.cover;
    }

    var attach = {
      video_resources: videoResources,
      note_title: shareInfo.title || '',
      note_text: content,
      note_text_v2: {
        content: content,
      },
      now_edit_info: {
        tti_open_keyboard: false,
      },
    };
    var pageInfo = { page_type: 'video_publish' };
    var source = {
      type: 'system_album_other',
      externalSource: 'rednote_publish_direct',
      extraInfo: { subType: 'external_app' },
    };
    var schema =
      'xhsdiscover://post_new_note?attach=' +
      encodeURIComponent(JSON.stringify(attach)) +
      '&page=' +
      encodeURIComponent(JSON.stringify(pageInfo)) +
      '&source=' +
      encodeURIComponent(JSON.stringify(source));

    return (
      'https://oia.xiaohongshu.com/oia?deeplink=' +
      encodeURIComponent(schema)
    );
  }

  function buildPublishRoute(shareInfo) {
    if (!canOpenPublish(shareInfo)) return null;

    var env = getEnvironment();
    var images = normalizeImages(shareInfo);
    var url = '';
    var launchMethod = env.isIOS ? 'anchor' : 'location';

    if (env.isHarmonyOS) {
      if (env.isHarmonyUniversalLinkPreferred) {
        url = buildHarmonyUniversalLinkRoute(shareInfo);
        launchMethod = 'anchor';
      } else {
        url = buildHarmonyRoute(shareInfo);
      }
    } else if (env.isAndroidLike) {
      url = buildAndroidRoute(shareInfo);
    } else if (env.isIOS && hasValidNormalMedia(shareInfo)) {
      url = buildIOSRoute(shareInfo, images);
    } else if (env.isIOS && hasValidVideoMedia(shareInfo)) {
      url = buildIOSVideoRoute(shareInfo);
    } else if (env.isIOS) {
      url = buildIOSShareSdkRoute(shareInfo);
    }

    if (!url) return null;

    return {
      url: url,
      fallbackUrl: '',
      launchMethod: launchMethod,
      platform: env.isHarmonyOS
        ? 'harmonyos'
        : env.isAndroidLike
          ? 'android'
          : 'ios',
    };
  }

  function scheduleAppLaunchFallback(fallbackUrl) {
    if (!fallbackUrl) return;

    var timer = window.setTimeout(function () {
      if (!document.hidden && !document.webkitHidden) {
        window.location.href = fallbackUrl;
      }
    }, 1200);
    var clear = function () {
      window.clearTimeout(timer);
    };

    window.addEventListener('pagehide', clear, { once: true });
    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden || document.webkitHidden) clear();
      },
      { once: true }
    );
  }

  function shouldGuideOpenInBrowser() {
    return getEnvironment().isInAppBrowser;
  }

  function injectGuideStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#' +
      GUIDE_ID +
      '{--rn-guide-overlay:linear-gradient(180deg,rgba(0,0,0,.68) 0%,rgba(0,0,0,.48) 42%,rgba(0,0,0,.64) 100%);--rn-guide-panel:rgba(22,22,24,.68);--rn-guide-panel-border:rgba(255,255,255,.1);--rn-guide-title:rgba(255,255,255,.9);--rn-guide-text:rgba(255,255,255,.72);--rn-guide-muted:rgba(255,255,255,.64);--rn-guide-button-bg:rgba(255,255,255,.9);--rn-guide-button-text:#374151;position:fixed;inset:0;z-index:2147483647;background:var(--rn-guide-overlay);color:var(--rn-guide-title);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;-webkit-font-smoothing:antialiased;}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-arrow{position:absolute;top:20px;right:18px;width:154px;height:120px;color:#fff;filter:drop-shadow(0 2px 8px rgba(0,0,0,.38));}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-tip{position:absolute;top:104px;right:26px;height:28px;padding:0 11px;border-radius:999px;background:rgba(255,255,255,.12);font-size:13px;line-height:28px;color:rgba(255,255,255,.8);text-shadow:0 1px 6px rgba(0,0,0,.38);}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-close{position:absolute;top:18px;left:18px;width:38px;height:38px;border:1px solid rgba(255,255,255,.18);border-radius:999px;background:rgba(0,0,0,.24);color:rgba(255,255,255,.82);font-size:26px;line-height:34px;}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-panel{position:absolute;top:176px;left:28px;right:28px;max-width:420px;margin:0 auto;padding:22px 20px 20px;border-radius:8px;background:var(--rn-guide-panel);border:1px solid var(--rn-guide-panel-border);box-shadow:0 12px 36px rgba(0,0,0,.24);text-align:left;}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-kicker{display:inline-flex;align-items:center;height:24px;padding:0 9px;margin-bottom:13px;border-radius:999px;background:rgba(255,255,255,.08);color:var(--rn-guide-muted);font-size:12px;font-weight:700;}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-title{font-size:22px;font-weight:800;line-height:1.28;margin-bottom:10px;letter-spacing:0;color:var(--rn-guide-title);}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-text{font-size:15px;line-height:1.68;color:var(--rn-guide-text);}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-copy{margin-top:20px;width:100%;height:46px;border:0;border-radius:8px;background:var(--rn-guide-button-bg);color:var(--rn-guide-button-text);font-size:16px;font-weight:800;box-shadow:0 8px 18px rgba(0,0,0,.16);}' +
      '#' +
      GUIDE_ID +
      ' .rn-guide-copy:active{transform:translateY(1px);}' +
      '@media (max-width:360px){#' +
      GUIDE_ID +
      ' .rn-guide-panel{left:18px;right:18px;top:164px;padding:21px 18px 19px}#' +
      GUIDE_ID +
      ' .rn-guide-title{font-size:21px}#' +
      GUIDE_ID +
      ' .rn-guide-text{font-size:15px}#' +
      GUIDE_ID +
      ' .rn-guide-arrow{right:8px;width:138px}#' +
      GUIDE_ID +
      ' .rn-guide-tip{right:18px}}' +
      '#' +
      GUIDE_ID +
      ' button{cursor:pointer;-webkit-tap-highlight-color:transparent;}';
    document.head.appendChild(style);
  }

  function copyText(text, button) {
    function markCopied() {
      if (!button) return;
      var oldText = button.textContent;
      button.textContent = '已复制页面链接';
      window.setTimeout(function () {
        button.textContent = oldText;
      }, 1600);
    }

    if (window.navigator.clipboard && window.navigator.clipboard.writeText) {
      window.navigator.clipboard.writeText(text).then(markCopied, function () {
        fallbackCopyText(text);
        markCopied();
      });
      return;
    }

    fallbackCopyText(text);
    markCopied();
  }

  function fallbackCopyText(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    document.body.removeChild(textarea);
  }

  function showOpenInBrowserGuide(options) {
    var opts = options || {};

    if (!document.body) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          showOpenInBrowserGuide(opts);
        },
        { once: true }
      );
      return;
    }

    injectGuideStyle();

    var existing = document.getElementById(GUIDE_ID);
    if (existing) {
      existing.style.display = 'block';
      return;
    }

    var env = getEnvironment();
    var pageUrl = opts.pageUrl || window.location.href;
    var appName = env.inAppBrowser ? env.inAppBrowser.name : '当前应用';
    var guide = document.createElement('div');
    guide.id = GUIDE_ID;
    guide.innerHTML =
      '<svg class="rn-guide-arrow" viewBox="0 0 154 120" aria-hidden="true">' +
      '<path d="M16 88C45 35 103 25 136 31" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>' +
      '<path d="M120 14L141 32L122 53" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<div class="rn-guide-tip">点击右上角菜单</div>' +
      '<button class="rn-guide-close" type="button" aria-label="关闭">×</button>' +
      '<div class="rn-guide-panel" role="dialog" aria-modal="true">' +
      '<div class="rn-guide-kicker">当前在' +
      appName +
      '内打开</div>' +
      '<div class="rn-guide-title">请在系统浏览器中打开</div>' +
      '<div class="rn-guide-text">点击右上角“…”菜单，选择“在浏览器打开”。回到系统浏览器后，再继续发布到小红书。</div>' +
      '<button class="rn-guide-copy" type="button">复制页面链接</button>' +
      '</div>';

    guide.querySelector('.rn-guide-close').onclick = function () {
      guide.style.display = 'none';
    };
    guide.querySelector('.rn-guide-copy').onclick = function () {
      copyText(pageUrl, this);
    };

    document.body.appendChild(guide);
  }

  function hideOpenInBrowserGuide() {
    var guide = document.getElementById(GUIDE_ID);
    if (guide) {
      guide.style.display = 'none';
    }
  }

  function openPublish(shareInfo, options) {
    var route;

    if (shouldGuideOpenInBrowser()) {
      showOpenInBrowserGuide(options);
      return {
        ok: false,
        reason: 'in_app_browser',
      };
    }

    route = buildPublishRoute(shareInfo);
    if (!route) {
      return {
        ok: false,
        reason: 'unsupported',
      };
    }

    navigateToUrl(route.url, route.launchMethod);
    scheduleAppLaunchFallback(route.fallbackUrl);

    return {
      ok: true,
      route: route,
    };
  }

  window.RednoteAppLauncher = {
    version: '2026.05.23.1',
    getEnvironment: getEnvironment,
    shouldGuideOpenInBrowser: shouldGuideOpenInBrowser,
    showOpenInBrowserGuide: showOpenInBrowserGuide,
    hideOpenInBrowserGuide: hideOpenInBrowserGuide,
    canOpenPublish: canOpenPublish,
    buildPublishRoute: buildPublishRoute,
    openPublish: openPublish,
  };
})(window, document);
